export default __webpack_public_path__ + "static/media/app_example_1.b4175ce9.png";